import React from "react";

const UploadCompanyLogo = ({ color = "#B1B1B1" }) => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1491 4.04153C12.0843 4.19817 11.9744 4.33205 11.8334 4.42624C11.6924 4.52043 11.5267 4.57069 11.3571 4.57067H9.35714V7.71353C9.35714 7.94086 9.26684 8.15888 9.10609 8.31962C8.94535 8.48037 8.72733 8.57067 8.5 8.57067C8.27267 8.57067 8.05465 8.48037 7.89391 8.31962C7.73316 8.15888 7.64286 7.94086 7.64286 7.71353V4.57067H5.64286C5.47344 4.57053 5.30787 4.52017 5.16705 4.42598C5.02623 4.33179 4.91649 4.19797 4.85167 4.04144C4.78686 3.88491 4.76989 3.71269 4.8029 3.54652C4.83591 3.38035 4.91742 3.22769 5.03714 3.10782L7.89429 0.250674C8.055 0.0901595 8.27286 0 8.5 0C8.72714 0 8.945 0.0901595 9.10571 0.250674L11.9629 3.10782C12.0827 3.2276 12.1644 3.38024 12.1976 3.54643C12.2307 3.71262 12.2139 3.88491 12.1491 4.04153ZM1.07143 9.50896C0.919876 9.50896 0.774531 9.56916 0.667368 9.67633C0.560204 9.78349 0.5 9.92884 0.5 10.0804L0.5 14.2747C0.5 14.4998 0.544341 14.7227 0.630492 14.9307C0.716643 15.1387 0.842917 15.3277 1.0021 15.4869C1.16129 15.646 1.35027 15.7723 1.55826 15.8585C1.76624 15.9446 1.98916 15.989 2.21429 15.989H14.7857C15.2404 15.989 15.6764 15.8083 15.9979 15.4869C16.3194 15.1654 16.5 14.7293 16.5 14.2747V10.0804C16.5 9.92884 16.4398 9.78349 16.3326 9.67633C16.2255 9.56916 16.0801 9.50896 15.9286 9.50896H12.5309C12.0762 9.50896 11.6402 9.68957 11.3187 10.0111C10.9972 10.3326 10.8166 10.7686 10.8166 11.2232C10.8166 12.3364 9.70114 13.2027 8.49657 13.1947C7.32629 13.1867 6.24514 12.317 6.24514 11.2232C6.24514 10.7686 6.06453 10.3326 5.74304 10.0111C5.42155 9.68957 4.98551 9.50896 4.53086 9.50896H1.07143Z"
        fill={color}
      />
    </svg>
  );
};

export default UploadCompanyLogo;

